import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import exportTransactionReport from "src/configs/apis/consumer-engagement/getExportTransactionReports.api";
import TngTransactionReportTableComponent from "./tngTransactionReportTable.component";
import { selectLoading } from "../../../../notification";
import {
  getTransactionReports,
  resetTransactionReportSelected,
  resetTransactionReportsRecord,
} from "../../../redux";
import TngReportDetailDialog from "../../dialog/tng-report-detail-dialog";

export default function TngTransactionReportTableContainer() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.transactionReport.records.data);
  const totalRow = useSelector(
    (state) => state.transactionReport.records.totalRecords
  );
  const isFetching = useSelector((state) =>
    selectLoading(state, getTransactionReports.typePrefix)
  );

  const [tableFilter, setTableFilter] = useState({
    page: 0,
    rowsPerPage: 25,
  });

  const [selected, setSelected] = useState(null);

  const fetchData = () => {
    dispatch(
      getTransactionReports({
        page: tableFilter.page + 1,
        length: tableFilter.rowsPerPage,
      })
    );
  };

  const handleChangePage = (newPage) => {
    setTableFilter({
      ...tableFilter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setTableFilter({
      ...tableFilter,
      page: 0,
      rowsPerPage: event,
    });
  };

  const handleClose = () => {
    setSelected(null);
  };

  const handleExport = async (format) => {
    try {
      const response = await exportTransactionReport({
        format,
        page: tableFilter.page + 1,
        length: tableFilter.rowsPerPage,
      });
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.download = `Daily_Disbursement_Report.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed", error);
    }
  };

  useEffect(() => {
    fetchData();

    return () => {
      dispatch(resetTransactionReportsRecord());
      dispatch(resetTransactionReportSelected());
    };
  }, [dispatch, tableFilter]);

  return (
    <>
      <TngTransactionReportTableComponent
        data={data}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        tableFilter={tableFilter}
        totalRow={totalRow}
        isFetching={isFetching}
        setSelected={setSelected}
        handleExport={handleExport}
      />
      {selected && (
        <TngReportDetailDialog date={selected.date} handleClose={handleClose} />
      )}
    </>
  );
}
